import { toast } from "sonner";

export function celebrate(message, opts = {}) {
  toast.success(message, {
    duration: opts.duration || 5000,
    className: "cams-celebrate",
    description: opts.description,
  });
}
